import { render, staticRenderFns } from "./ImageSlider1.vue?vue&type=template&id=a823ee32"
import script from "./ImageSlider1.vue?vue&type=script&lang=ts"
export * from "./ImageSlider1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports